import { Schema, Node as ProseNode } from "prosemirror-model";
import { Command, EditorState, Transaction } from "prosemirror-state";
import { EditorView } from "prosemirror-view";

export function isEmptySurveyDoc(doc: ProseNode, schema: Schema): boolean {
	if (doc.childCount !== 2) {
		return false;
	}

	const firstChild = doc.child(0);
	const secondChild = doc.child(1);

	if (firstChild.childCount !== 1 || secondChild.childCount !== 1) {
		return false;
	}

	const firstSubChild = firstChild.child(0);
	const secondSubChild = secondChild.child(0);

	if (firstSubChild.type !== schema.nodes.paragraph) {
		return false;
	}

	if (secondSubChild.type !== schema.nodes.page_separator) {
		return false;
	}

	if (firstSubChild.firstChild !== null && !firstSubChild.firstChild.isText) {
		return false;
	}

	return (
		(
			firstSubChild.firstChild === null
			//@ts-ignore
			|| firstSubChild.firstChild.text.trim().length === 0
		)
		&& secondSubChild.attrs.isLast
	);
}

export function isEmptySurveyDocJson(jsonDoc: {[key: string]: any}, schema: Schema): boolean {
	const doc = schema.nodeFromJSON(jsonDoc);

	return isEmptySurveyDoc(doc, schema);
}


export default function scrollToPos(
	pos: number,
	scrollArgs?: {
		block: ScrollLogicalPosition,
		behavior: ScrollBehavior,
		inline: ScrollLogicalPosition
	}
): Command {
    return function(state: EditorState, dispatch: ((tr: Transaction) => void) | undefined, view?: EditorView): boolean {
		if (view === undefined) {
			return false;
		}

        const domAtPos = view.domAtPos(pos);

		let scrollEl: HTMLElement | null = domAtPos.node as HTMLElement;

        if (scrollEl?.nodeType === Node.TEXT_NODE) {
            scrollEl = scrollEl.parentElement;
        }

        if (scrollEl && dispatch) {
            scrollEl.scrollIntoView({
                block: scrollArgs?.block ?? 'center',
                behavior: scrollArgs?.behavior ?? 'smooth',
                inline: scrollArgs?.inline ?? 'nearest',
            });
        }

        return !!scrollEl;
    };
}
